// Google Analytics 4 (GA4) utility functions
declare global {
  interface Window {
    gtag: (...args: any[]) => void;
    dataLayer: any[];
  }
}

// Initialize Google Analytics (already loaded via script tag)
export const initGA = () => {
  if (typeof window !== 'undefined' && typeof window.gtag === 'function') {
    // GA ready - no console output
  }
};

// Track page views
export const trackPageView = (page: string) => {
  if (typeof window !== 'undefined' && typeof window.gtag === 'function') {
    try {
      window.gtag('config', 'G-5RPW8Q9K3T', {
        page_title: page,
        page_location: window.location.href,
      });
    } catch (_error) {
      // Tracking may be blocked by extension
    }
  }
};

// Track custom events
export const trackEvent = (action: string, category: string, label?: string, value?: number) => {
  if (typeof window !== 'undefined' && typeof window.gtag === 'function') {
    try {
      window.gtag('event', action, {
        event_category: category,
        event_label: label,
        value: value,
      });
    } catch (_error) {
      // Tracking may be blocked by extension
    }
  }
};

// Track user engagement events
export const trackHikeAdded = (hikeName: string, location: string) => {
  trackEvent('hike_added', 'hike_management', `${hikeName} - ${location}`);
};

export const trackHikeCompleted = (hikeName: string, location: string, rating?: number) => {
  trackEvent('hike_completed', 'hike_management', `${hikeName} - ${location}`, rating);
};

export const trackHikeLiked = (hikeName: string) => {
  trackEvent('hike_liked', 'social_interaction', hikeName);
};

export const trackAchievementUnlocked = (achievementName: string) => {
  trackEvent('achievement_unlocked', 'achievements', achievementName);
};

export const trackUserRegistration = (method: string) => {
  trackEvent('user_registration', 'user_management', method);
};

export const trackUserLogin = (method: string) => {
  trackEvent('user_login', 'user_management', method);
};

export const trackWishlistHikeAdded = (hikeName: string, location: string) => {
  trackEvent('wishlist_hike_added', 'wishlist_management', `${hikeName} - ${location}`);
};

export const trackFriendAdded = () => {
  trackEvent('friend_added', 'social_interaction', 'friend_management');
};

export const trackWeatherConditionSelected = (condition: string) => {
  trackEvent('weather_condition_selected', 'hike_details', condition);
};

export const trackMapViewed = (hikeName: string) => {
  trackEvent('map_viewed', 'hike_details', hikeName);
};

export const trackPhotoUploaded = (hikeName: string) => {
  trackEvent('photo_uploaded', 'hike_details', hikeName);
};

export const trackSearchPerformed = (searchTerm: string) => {
  trackEvent('search_performed', 'search', searchTerm);
};

export const trackFilterApplied = (filterType: string, filterValue: string) => {
  trackEvent('filter_applied', 'search', `${filterType}: ${filterValue}`);
}; 